import { format } from 'date-fns';

import isValidDate from './is-valid-date';

const formatYear = (defaultValue) => (date) => (isValidDate(date) ? format(date, 'yyyy') : defaultValue);

export default formatYear;
